<div class="row no-gutters">
  <div class="col-xxl-10 offset-xxl-1">
    <h1 class="my-4">
      Resources
    </h1>

    @if (newsletter) {
      <div>
        <div class="row" style="min-height:350px">
          <div class="col-sm-4" style="max-width:300px;max-height:320px;/*fix for ie CWS-743#3*/">
            <a href="{{contentBaseUrl}}{{newsletter.Link}}" target="_blank" aria-label="Quarterly Portfolio Review">
              <img src="{{imageBaseUrl}}{{newsletter.Image}}" alt="Quarterly Portfolio Review Document Preview" class="img-fluid" style="max-height: 100%;" />
            </a>
          </div>
          <div class="col-sm-8 pt-3 pt-sm-0">
            <p><b>{{newsletter.Title}}</b></p>
            <p [innerHTML]="newsletter.Summary"></p>
            <a href="{{contentBaseUrl}}{{newsletter.Link}}" target="_blank">
              Click Here To View
            </a>
            <p class="pt-5">
              <label for="past-dates-selection">Past Editions:</label>
              <select class="form-control" style="width: auto;" (change)="download()" [(ngModel)]="selected" id="past-dates-selection">
                <option value="">Select Period to Download</option>
                @for (n of newsletters; track n) {
                  <option [ngValue]="n.Link">{{n.formattedDate}} </option>
                }
              </select>
            </p>
          </div>
        </div>
      </div>
    }
  </div>
</div>
